import { DOC_TYPE } from '@src/page/toc/common/meeting-room-manager/message_const';
import { InitData } from './meeting-room-interface';

/**
 * MeetingRoom 判断初始化参数是否完备
 * @param initData 初始 MeetingRoom 用参数
 * @returns {boolean}
 */
export const isMeetingRoomDataReady = (initData: InitData): boolean => {
    const { sceneSource, roomId, docId, docType, role } = initData;
    if (!Object.values(DOC_TYPE).includes(docType)) {
        return false;
    }
    return Boolean(docId && role && roomId && sceneSource);
};
